import {Section} from '..';
import {Paper, Typography} from '@material-ui/core';
import {AutoField} from '../fields';
import {useFieldData} from '../hooks';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
import {Show} from 'components';
import {useContext} from 'react';
import {UserContext} from 'context/UserContext';
import {AddMMCCore} from 'components/mmld/AddMMC';
import {H5} from 'components/TypographyShortcuts';
import ViewMMCMini from 'components/mmld/ViewMMCMini';

const MMCInfo = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(existingData, sectionFields, fieldDict);
    const {hasMmlds, user} = useContext(UserContext);

    const [hasMMC, setHasMMC] = useFieldData('applicant_previous_mmc');

    return (
        <>
            <Section {...props} schema={schema} initialValues={initialValues}>
                <Typography variant='h6' align='left'>
                    {sectionName}
                </Typography>
                <Show condition={hasMmlds}>
                    <H5 align='center'>
                        We found your MMC info. You're good to go.
                    </H5>
                    <ViewMMCMini />
                    <input hidden name='applicant_previous_mmc' value='true' />
                    <input hidden name='applicant_MMC' value={user.mmld_number} />
                </Show>
                <Show condition={!hasMmlds}>
                    <AutoField
                        field={fieldDict.applicant_previous_mmc}
                        name='applicant_previous_mmc'
                        onChange={e => setHasMMC(e.target.value === 'true')}
                    />
                    <AutoField
                        field={fieldDict.applicant_MMC}
                        name='applicant_MMC'
                    />
                </Show>
            </Section>
            <Show condition={!hasMmlds && (hasMMC === 'true' || hasMMC === true)}>
                <Paper elevation={5} style={{padding: '1rem', marginTop: '2rem'}}>
                    <div style={{margin: '1rem'}}>
                        <H5 align='center'>Let's Look Up Your MMC</H5>
                    </div>
                    <div>
                        <AddMMCCore ButtonProps={{fullWidth: true}} />
                    </div>
                </Paper>
            </Show>
        </>
    );
};
export default MMCInfo;
